module.exports = __webpack_public_path__ + "img/logo_standard.c1319599.svg";